"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _AppBar = _interopRequireDefault(require("@mui/material/AppBar"));
var _ToggleButton = _interopRequireDefault(require("@mui/material/ToggleButton"));
var _ToggleButtonGroup = _interopRequireDefault(require("@mui/material/ToggleButtonGroup"));
var _Toolbar = _interopRequireDefault(require("@mui/material/Toolbar"));
var _styles = require("@mui/styles");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _Flex = _interopRequireDefault(require("./Flex"));
var _Hidden = _interopRequireDefault(require("./Hidden"));
var _String = _interopRequireDefault(require("./String"));
var _withMobile = _interopRequireDefault(require("../Hoc/withMobile.js"));
var _Menu = _interopRequireDefault(require("@mui/icons-material/Menu"));
var _AppBarModule = _interopRequireDefault(require("./AppBar.module.scss"));
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _styles.makeStyles)(theme => {
  return {
    toggleButton: props => ({
      "&.Mui-selected": {
        backgroundColor: `color-mix(in srgb, ${theme.palette[props.color].main} 75%, ${theme.palette.mode !== "dark" ? "white" : "black"}) !important`,
        color: "currentColor !important"
      },
      "&:hover": {
        backgroundColor: `color-mix(in srgb, ${theme.palette[props.color].main} 90%, ${theme.palette.mode !== "dark" ? "white" : "black"}) !important`
      }
    }),
    primary: {
      "backgroundColor": `${theme.palette.primary.main} !important`,
      "color": `${theme.palette.primary.contrastText} !important`,
      "&.Mui-selected": {
        backgroundColor: `color-mix(in srgb, ${theme.palette.primary.main} 75%, ${theme.palette.mode !== "dark" ? "white" : "black"}) !important`,
        color: "currentColor !important"
      },
      "&:hover": {
        backgroundColor: `color-mix(in srgb, ${theme.palette.primary.main} 90%, ${theme.palette.mode !== "dark" ? "white" : "black"}) !important`
      }
    },
    secondary: {
      "backgroundColor": `${theme.palette.secondary.main} !important`,
      "color": `${theme.palette.secondary.contrastText} !important`,
      "&.Mui-selected": {
        backgroundColor: `color-mix(in srgb, ${theme.palette.secondary.main} 75%, ${theme.palette.mode !== "dark" ? "white" : "black"}) !important`,
        color: "currentColor !important"
      },
      "&:hover": {
        backgroundColor: `color-mix(in srgb, ${theme.palette.secondary.main} 90%, ${theme.palette.mode !== "dark" ? "white" : "black"}) !important`
      }
    },
    error: {
      "backgroundColor": `${theme.palette.error.main} !important`,
      "color": `${theme.palette.error.contrastText} !important`,
      "&.Mui-selected": {
        backgroundColor: `color-mix(in srgb, ${theme.palette.error.main} 75%, ${theme.palette.mode !== "dark" ? "white" : "black"}) !important`,
        color: "currentColor !important"
      },
      "&:hover": {
        backgroundColor: `color-mix(in srgb, ${theme.palette.error.main} 90%, ${theme.palette.mode !== "dark" ? "white" : "black"}) !important`
      }
    },
    warning: {
      "backgroundColor": `${theme.palette.warning.main} !important`,
      "color": `${theme.palette.warning.contrastText} !important`,
      "&.Mui-selected": {
        backgroundColor: `color-mix(in srgb, ${theme.palette.warning.main} 75%, ${theme.palette.mode !== "dark" ? "white" : "black"}) !important`,
        color: "currentColor !important"
      },
      "&:hover": {
        backgroundColor: `color-mix(in srgb, ${theme.palette.warning.main} 90%, ${theme.palette.mode !== "dark" ? "white" : "black"}) !important`
      }
    },
    info: {
      "backgroundColor": `${theme.palette.info.main} !important`,
      "color": `${theme.palette.info.contrastText} !important`,
      "&.Mui-selected": {
        backgroundColor: `color-mix(in srgb, ${theme.palette.info.main} 75%, ${theme.palette.mode !== "dark" ? "white" : "black"}) !important`,
        color: "currentColor !important"
      },
      "&:hover": {
        backgroundColor: `color-mix(in srgb, ${theme.palette.info.main} 90%, ${theme.palette.mode !== "dark" ? "white" : "black"}) !important`
      }
    },
    success: {
      "backgroundColor": `${theme.palette.success.main} !important`,
      "color": `${theme.palette.success.contrastText} !important`,
      "&.Mui-selected": {
        backgroundColor: `color-mix(in srgb, ${theme.palette.success.main} 75%, ${theme.palette.mode !== "dark" ? "white" : "black"}) !important`,
        color: "currentColor !important"
      },
      "&:hover": {
        backgroundColor: `color-mix(in srgb, ${theme.palette.success.main} 90%, ${theme.palette.mode !== "dark" ? "white" : "black"}) !important`
      }
    }
  };
});

/**
 * App bar component
 *
 * @package HOPS
 * @subpackage Ui
 * @copyright Heritage Operations Processing Limited
 */
const AppBar = props => {
  const classes = useStyles(props);
  const [menuOpen, setMenuOpen] = (0, _react.useState)(false);
  const stringProps = {
    lineClamp: 1,
    noFlex: true
  };
  const handleMenuChoice = (e, value, menu) => {
    setMenuOpen(false);
    return menu?.onChange(e, value);
  };
  const renderToggleButtonMenu = menu => {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ToggleButtonGroup.default, {
      className: `${_AppBarModule.default.nav} ${props.isMobile && _AppBarModule.default.navMobile}`,
      color: props.color,
      exclusive: true,
      onChange: (e, value) => handleMenuChoice(e, value, menu),
      orientation: props.isMobile ? "vertical" : "horizontal",
      value: menu?.value,
      children: menu?.items?.map((item, key) => {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ToggleButton.default, {
          className: `${classes.toggleButton} ${item.color ? classes[item.color] : undefined}`,
          value: item.value,
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Flex.default, {
            columnar: true,
            gap: 0.5,
            children: [item.icon, /*#__PURE__*/(0, _jsxRuntime.jsx)(_String.default, {
              ...stringProps,
              str: item.label
            })]
          })
        }, key);
      })
    });
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_AppBar.default, {
    color: props.color,
    position: "sticky",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Toolbar.default, {
      disableGutters: true,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Flex.default, {
        alignItems: "center",
        className: props.isMobile ? _AppBarModule.default.containerReduced : _AppBarModule.default.container,
        fullWidth: true,
        justifyContent: "space-between",
        gap: 1,
        px: 1,
        py: props.isMobile ? 1 : 0,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Flex.default, {
          alignItems: "center",
          columnar: true,
          fullWidth: true,
          justifyContent: "space-between",
          gap: 1,
          children: [props.children, /*#__PURE__*/(0, _jsxRuntime.jsx)(_Hidden.default, {
            hidden: !props.isMobile,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Flex.default, {
              className: _AppBarModule.default.nav,
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ToggleButton.default, {
                className: classes.toggleButton,
                onChange: () => {
                  setMenuOpen(!menuOpen);
                },
                selected: menuOpen,
                style: {
                  float: "end"
                },
                value: "mobileNav",
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Menu.default, {})
              })
            })
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Hidden.default, {
          hidden: props.isMobile && !menuOpen,
          children: [props.centreMenu && renderToggleButtonMenu(props.centreMenu) || props.centreContent || null, props.rightMenu && renderToggleButtonMenu(props.rightMenu) || props.rightContent || null]
        })]
      })
    })
  });
};
AppBar.propTypes = {
  color: _propTypes.default.oneOf(["default", "inherit", "primary", "secondary", "transparent", "error", "info", "success", "warning"])
};
AppBar.defaultProps = {
  color: "primary"
};
var _default = exports.default = (0, _withMobile.default)(AppBar);